import React from "react"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"

const FullScreen = ({ children, classes }) => (
  <div>
    <p>Full Screen</p>
  </div>
)

export default withStyles(styles, { withTheme: true })(FullScreen)



// WEBPACK FOOTER //
// ./src/components/Template/Layouts/FullScreen/index.jsx